import { BaseResponseAttributes } from "../attributes/base-attributes";
import { RestApiResponse } from "./RestApi";
import BaseService from "./BaseService";
import { AddRequestCountryAttributes } from "../attributes/country-attributes";

export class CountryService extends BaseService {
  static async supportedCountries(): Promise<
    RestApiResponse<BaseResponseAttributes>
  > {
    return CountryService.getPublicApiClient().get("countries");
  }

  static countryActivation(
    countryId: number
  ): Promise<RestApiResponse<BaseResponseAttributes>> {
    return CountryService.getApiClient().put(
      `admin/countries/${countryId}/activate`
    );
  }

  static updateCountry(
    countryId: number,
    currencyCode: string,
    currencyDesignation: string
  ): Promise<RestApiResponse<BaseResponseAttributes>> {
    let data = {
      currency_code: currencyCode,
      currency_designation: currencyDesignation,
    };

    return CountryService.getApiClient().put(
      `admin/countries/${countryId}/update`,
      data
    );
  }

  static async addCountry(
    data: AddRequestCountryAttributes
  ): Promise<RestApiResponse<BaseResponseAttributes>> {
    return CountryService.getApiClient().post(`admin/countries/add`, {
      ...data,
    });
  }

  static supportedCurrencies(): Promise<
    RestApiResponse<BaseResponseAttributes>
  > {
    return CountryService.getApiClient().get(`admin/currencies`);
  }

  static getCountriesToAddOrUpdate(
    page?: number
  ): Promise<RestApiResponse<BaseResponseAttributes>> {
    return CountryService.getPublicApiClient().get(`countries/add-or-update`, {
      params: { page: page },
    });
  }
}

export default CountryService;
